(function () {
  class Freespins {
    constructor() {
      var self = this;
      this._startHolder = undefined;
      this._endHolder = undefined;
      this._fsCountText = undefined;
      this._fsWinningsMeter = undefined;
      this._fsActive = false;
      this._freespinsCount = 0;
      this._spinsLeft = 0;
      this._outroPopup = undefined;
      this._outroPopupButton = undefined;
      this._winningsThisSpin = 0;
      this._inFBL = false;
      this._bonusSymbolPos = undefined;
      this._freespinsTune = undefined;

      this._doSpinFunc = this.doSpin.bind(this);
      this._doSpinDeadFunc = this.doSpinDead.bind(this);
      this._onfireballLinkStartEventFunc =
        this.onfireballLinkStartEvent.bind(this);
      this._onfireballLinkEndEventFunc = this.fireballLinkEndEvent.bind(this);
      messageBus.subscribe(
        "spinner:GameConfigEvent",
        this.onGameConfigEvent.bind(this)
      );
      messageBus.subscribe(
        "spinner:FreeSpinsStartEvent",
        this.onFreespinsStart.bind(this)
      );
      messageBus.subscribe(
        "spinner:FreeSpinsStartEventDead",
        this.onFreespinsStartDead.bind(this)
      );
      messageBus.subscribe(
        "spinner:FreeSpinsDataEvent",
        this.onFreespinsData.bind(this)
      );
      messageBus.subscribe(
        "spinner:FreeSpinsDataEventDead",
        this.onFreespinsDataDeadEvent.bind(this)
      );
      messageBus.subscribe(
        "spinner:FreeSpinsEndEvent",
        this.onFreespinsEndEvent.bind(this)
      );
      messageBus.subscribe(
        "spinner:WinningLinesEvent",
        this.doPayWins.bind(this)
      );
      this._payWinsDeadFunc = this.doPayWinsDead.bind(this);
      messageBus.subscribe(
        "bountyhunter:skipWins",
        this.skipAnimations.bind(this)
      );
      Reflex.registerEventHandler(
        "orientationChange",
        this.onOrientationChange.bind(this)
      );
      Reflex.registerEventHandler(
        "layoutChange",
        this.onLayoutChange.bind(this)
      );
      messageBus.subscribe(
        "spinner:FreeSpinsAwardEventDead",
        this.onFreespinsAwardedEnd.bind(this)
      );
      messageBus.subscribe(
        "8bof:FireballAwards",
        this.onFireballAwardsEvent.bind(this)
      );

      StateMachine.Create(this);
      Reflex.addToUpdate(function (delta, time) {
        self.update(delta, time);
      });

      this.stateMachine.addState("IDLE", function () {});
      this.stateMachine.addState("OUTRO", function () {
        self.update_outroState();
      });
      this.stateMachine.addState("OUTRO_POPUP", function () {
        self.update_outroPopupState();
      });

      this.stateMachine.addState("PREBIGWIN", function () {
        self.update_preBigWinState();
      });
    }

    update(delta, time) {
      if (this.stateMachine) {
        this.stateMachine.update();
      }
    }

    skipAnimations() {}

    onOrientationChange() {
      if (this._fsActive) {
        this._logo.visible = false;
        if (this._bg !== undefined) {
          this._bgLandscape.alpha = this._bg.alpha;
          this._bgPortrait.alpha = this._bg.alpha;
          this._bgLandscape.visible = this._bg.visible;
          this._bgPortrait.visible = this._bg.visible;
          switch (layoutController.getCurrentLayout()) {
            case "landscape_default":
            case "landscape_mobile": {
              this._bgPortrait.alpha = 1;
              this._bgPortrait.visible = false;
              this._bg = this._bgLandscape;
              break;
            }
            case "portrait_default":
            case "portrait_mobile": {
              this._bgLandscape.alpha = 1;
              this._bgLandscape.visible = false;
              this._bg = this._bgPortrait;
              break;
            }
          }
        }
        const fsCreditMeterPos = resourceManager.get(
          "creditContainer_freespinsPosition"
        ).position;
        this._baseCreditMeterContainer.position.set(
          fsCreditMeterPos.getX(),
          fsCreditMeterPos.getY()
        );
        const fsStakeMeterPos = resourceManager.get(
          "betContainer_freespinsPosition"
        ).position;
        this._baseStakeMeterContainer.position.set(
          fsStakeMeterPos.getX(),
          fsStakeMeterPos.getY()
        );
      }
    }

    onLayoutChange() {
      if (this._fsActive) {
        this.onOrientationChange();
      }
    }

    hideAllAnimations() {}

    update_outroPopupState() {
      if (this.phase.enter()) {
        this._outroPopup.visible = true;
        this._outroPopup.alpha = 0;
      }

      if (this.phase.timed(500)) {
        this._popupMaskDimObject.show(true, this.phase.Progress);
        this._outroPopup.alpha = this.phase.Progress;
      }

      if (this.phase.once()) {
        this._outroPopup.alpha = 1;
        this._outroPopupButton.interactive = true;
        const self = this;
        this._outroPopupButton.touchend = this._outroPopupButton.mouseup =
          function () {
            self.stateMachine.switchState("OUTRO");
            self._outroPopupButton.interactive = false;
            self._outroPopupButton.touchend = self._outroPopupButton.mouseup =
              function () {};
          };
      }
    }

    update_outroState() {
      if (this.phase.enter()) {
        this._logo.alpha = 0;

        this._popupMaskDimObject.show(false);
        this._outroPopup.alpha = 1;
        this._outroPopup.visible = false;
        gameData.winningsMeter.set(this._winnings);
      }

      if (this.phase.timed(1000)) {
        const progress = this.phase.Progress;
        this._freespinElements.forEach(function (element) {
          element.alpha = 1 - progress;
        });
        this._logo.alpha = progress;

        this._bg.alpha = 1 - progress;
      }

      if (this.phase.once()) {
        const fsCreditMeterPos =
          layoutController.getCurrentPosition("creditContainer");
        this._baseCreditMeterContainer.position.set(
          fsCreditMeterPos.x,
          fsCreditMeterPos.y
        );
        const fsStakeMeterPos =
          layoutController.getCurrentPosition("betContainer");
        this._baseStakeMeterContainer.position.set(
          fsStakeMeterPos.x,
          fsStakeMeterPos.y
        );

        this._bg.alpha = 1;
        this._bg.visible = false;

        this._logo.visible = true;
        this._logo.alpha = 0;

        this._bgLandscape.visible = false;
        this._bgPortrait.visible = false;

        gsap.to(this._logo, {
          duration: 0.3,
          alpha: 1,
        });

        resourceManager.getContainer("freespinsContainer").visible = false;
        resourceManager.getContainer(
          "freespinsBehindGameContainer"
        ).visible = false;
        this.stateMachine.switchState("IDLE");
      }

      if (this.phase.exit()) {
        //gameData.musicManager.startIdleMusic(10, false);

        this._endHolder.leave();
        this._fsActive = false;
        this._fsCountText.visible = false;
        resourceManager.getController("inputOverlord").setState("enabled");
        gameController.freespinsComplete(this._endHolder.data.fsWinnings);
      }
    }

    onGameConfigEvent() {
      this._bgLandscape = resourceManager.get(
        "baseGameBackground:landscapeBackground:mountainsFreeSpins"
      );
      this._bgLandscape.visible = false;

      this._bgPortrait = resourceManager.get(
        "baseGameBackground:portraitBackground:mountainsFreeSpins"
      );
      this._bgPortrait.visible = false;

      this._bg = this._bgLandscape;

      resourceManager.getContainer("freespinsContainer").visible = true;
      resourceManager.getContainer(
        "freespinsBehindGameContainer"
      ).visible = true;
      this._freespinElements = [
        resourceManager.getContainer("freespinsContainer"),
        resourceManager.getContainer("freespinsBehindGameContainer"),
        resourceManager.get("totalWinningsContainer"),
        resourceManager.get("freespinsCountContainer"),
      ];
      this._freespinElements.forEach(function (element) {
        element.visible = false;
      });

      this._retriggerPopup = resourceManager.get(
        "featurePopupContainer:freespinsRetriggerPopup"
      );

      this._fireslots = resourceManager.get(
        "slotContainer:freespinsFireSlots:fireslotManager"
      );
      this._firelink = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:firelinkFeature"
      );

      this._logo = resourceManager.get("baseGameLogo");

      this._showIndividualWinsInFreespins = gdk.mustShowSlowWin();
      this._fsWinningsMeter = resourceManager.get(
        "totalWinningsContainer:winningsMeter"
      );

      this._volcanoWinValue = resourceManager.get(
        "hammerPotContainer:hammerPotValue"
      );

      this._potIncrease = resourceManager.get(
        "hammerPotContainer:increaseValue"
      );
      this._potIncrease.setText("");
      this._potIncrease.visible = false;

      this._potIncreaseHighlight = resourceManager.get(
        "hammerPotContainer:increaseValueHighlight"
      );
      this._potIncreaseHighlight.setText("");
      this._potIncreaseHighlight.visible = false;

      this._potIncreaseGlow = resourceManager.get(
        "hammerPotContainer:increaseGlow"
      );
      this._potIncreaseGlow.blendMode = PIXI.BLEND_MODES.ADD;
      this._potIncreaseGlow.visible = false;

      this._volcanoValueMoverEndPos = resourceManager.get(
        "hammerPotPanelTextContainer:volcanoValueMoverEndPos"
      );

      this._pot = resourceManager.get("hammerPotContainer:hammerPotPanel");

      this._baseCreditMeterContainer = resourceManager.get("creditContainer");
      this._baseStakeMeterContainer = resourceManager.get("betContainer");

      this._fsCountText = resourceManager.get(
        "freespinsCountContainer:freespinsCount"
      );

      this._introPopup = resourceManager.get(
        "featurePopupContainer:freespinsIntroPopup:FreeSpinsIntro"
      );
      this._introPopup.visible = false;

      this._fireballAwardsContainer = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:moneyPanel"
      );
      this._fireballAwardsContainer.visible = false;
      this._fireballAwardsValue = resourceManager.get(
        "slotContainer:firelinkFeatureContainer:moneyPanel:winnings"
      );

      this._outroPopupWin = resourceManager.get(
        "featurePopupContainer:freespinsOutroWinPopup"
      );
      this._outroPopupWin.visible = false;
      this._outroPopupWinButton = resourceManager.get(
        "featurePopupContainer:freespinsOutroWinPopup:bg:continueButton"
      );
      this._outroPopupWinValue = resourceManager.get(
        "featurePopupContainer:freespinsOutroWinPopup:bg:win"
      );

      this._lightningHammerPot = resourceManager.get("lightningPotPanel");
      this._lightningHammerPot.gotoAndStop(0);
      this._lightningHammerPot.visible = false;

      this._lightningWinPanel = resourceManager.get("lightningWinPanel");
      this._lightningWinPanel.gotoAndStop(0);
      this._lightningWinPanel.visible = false;

      this._vortex = resourceManager.get("baseGameBackground:vortex");

      this._popupMaskDimObject = resourceManager.get("popupMaskDimObject");

      this._fsCountWinner = resourceManager.get("fsCount");
      this._fsCountWinner.visible = false;
      this._fsTitleWinner = resourceManager.get("fsTitle");
      this._fsTitleWinner.visible = false;
    }

    updateCountText() {
      if (this._fsActive) {
        this._fsCountText.setTranslationParameters(
          this._freespinsCount - this._spinsLeft,
          this._freespinsCount
        );
        this._fsCountText.visible = true;
      }
    }

    doSpin(spinTask) {
      this._winningsThisSpin = 0;

      this._bonusSymbolPos = undefined;
      const symbols = resourceManager.getConfiguration().symbols;
      for (
        let reel = 0;
        reel < spinTask.data.resultPanel.reelList.length;
        ++reel
      ) {
        for (
          let row = 0;
          row < spinTask.data.resultPanel.reelList[reel].symbols.length;
          ++row
        ) {
          if (
            spinTask.data.resultPanel.reelList[reel].symbols[row].value ===
            symbols["Symbol_Bonus_Retrigger"].ID
          ) {
            this._bonusSymbolPos = { reel, row };
            break;
          }
        }
        if (this._bonusSymbolPos) {
          break;
        }
      }
    }

    doSpinDead(spinTask) {}

    onfireballLinkStartEvent() {
      this._inFBL = true;
    }

    fireballLinkEndEvent(task) {
      this._winnings += task.winAmount;
      this._winningsThisSpin += task.winAmount;
      this._fsWinningsMeter.set(this._winnings);
      this._inFBL = false;
    }

    getNextSpinOutcome() {
      this._firelink.showWinningsPanel(false, function () {});

      this.updateCountText();
      gameController.initNewSpin();

      gdk.getNextGameOutcome(function () {});
    }

    sortOutLayout() {
      switch (layoutController.getCurrentLayout()) {
        case "landscape_default": {
          resourceManager.get("freespinsTimeBackground").visible = true;
          resourceManager.get("freespinsStake").visible = true;
          resourceManager.get("freespinsCredit").visible = true;
          break;
        }
        case "portrait_default":
        case "portrait_mobile": {
          resourceManager
            .get("slotContainer")
            .position.setY(
              layoutController.getCurrentPosition("slotContainer").y - 150
            );
          resourceManager.get("freespinsTimeBackground").visible = false;
          resourceManager.get("freespinsStake").visible = false;
          resourceManager.get("freespinsCredit").visible = false;
          break;
        }

        case "landscape_mobile": {
          resourceManager
            .get("slotContainer")
            .position.setX(
              layoutController.getCurrentPosition("slotContainer").x + 50
            );
          resourceManager.get("freespinsTimeBackground").visible = false;
          resourceManager.get("freespinsStake").visible = false;
          resourceManager.get("freespinsCredit").visible = false;
          break;
        }
      }
    }

    processFireballAwards(callback) {
      this._fireballAwardIndex = 0;
      this._firelink.startShowPrizesFromExt(this._winningsThisSpin);
      this.processNextFireballAward(function () {
        callback();
      });
    }

    processNextFireballAward(callback) {
      if (
        this._fireballAwardIndex <
        this._fireballAwardsTask.data.fireballAwards.events.length
      ) {
        const award =
          this._fireballAwardsTask.data.fireballAwards.events[
            this._fireballAwardIndex++
          ];
        const self = this;
        this.processFireballAward(award, function () {
          self.processNextFireballAward(callback);
        });
      } else {
        callback();
      }
    }

    processFireballWin(award, callback) {
      switch (award.fireball.type) {
        case "Cash":
        case "WildCash": {
          this._firelink.setWinnings(this._fireballAwardWinnings);
          this._fireballAwardWinnings += award.winAmount;
          const prizeInfo = {
            reel: award.coord.reel,
            row: award.coord.row,
            prizeData: { type: "Cash", value: award.winAmount },
          };
          if (award.isDoubled) {
            const self = this;
            this._fireslots.animateX2(
              award.coord.reel,
              award.coord.row,
              function () {
                self._firelink.processPrize(prizeInfo, function () {
                  callback();
                });
              }
            );
          } else {
            this._firelink.processPrize(prizeInfo, function () {
              callback();
            });
          }
          break;
        }
        case "Pot":
        case "WildPot": {
          this._firelink.setWinnings(this._fireballAwardWinnings);
          this._fireballAwardWinnings += award.winAmount;
          const prizeInfo = {
            reel: award.coord.reel,
            row: award.coord.row,
            prizeData: {
              type: "Pot",
              potName: award.fireball.potName,
              value: award.winAmount,
              isDoubled: award.isDoubled,
            },
          };
          const self = this;
          if (award.isDoubled) {
            this._fireslots.animateX2(
              award.coord.reel,
              award.coord.row,
              function () {
                self._firelink.processPrize(prizeInfo, function () {
                  callback();
                });
              }
            );
          } else {
            this._firelink.processPrize(prizeInfo, function () {
              callback();
            });
          }
          break;
        }
        case "Multiplier":
        case "WildMultiplier": {
          this._firelink.setWinnings(this._fireballAwardWinnings);
          this._fireballAwardWinnings *= award.fireball.multiplier;
          this._firelink.processMultiplier(
            {
              reel: award.coord.reel,
              row: award.coord.row,
              prizeData: {
                type: "Multiplier",
                value: award.fireball.multiplier,
              },
            },
            function () {
              callback();
            }
          );
          break;
        }
        default: {
          console.log("fireball id error");
        }
      }
    }

    processFireballAward(award, callback) {
      switch (award.type) {
        case "Win": {
          const self = this;
          this._firelink.showWinningsPanel(true, function () {
            self.processFireballWin(award, callback);
          });
          break;
        }
        case "StateChange": {
          this._fireslots.activationChange(
            [
              {
                reel: award.coord.reel,
                row: award.coord.row,
                state: award.newState,
              },
            ],
            function () {
              callback();
            }
          );
          break;
        }
        case "VolcanoDoubled": {
          const self = this;
          if (award.isDoubled) {
            self._fireslots.animateX2(
              award.coord.reel,
              award.coord.row,
              function () {
                self.doubleVolcanoPot(award, function () {
                  callback();
                });
              }
            );
          } else {
            this.doubleVolcanoPot(award, function () {
              callback();
            });
          }
          break;
        }
        case "VolcanoBoost": {
          const self = this;
          soundManager.play("freeSpinsHammerLand");
          const symbols = resourceManager.getConfiguration().symbols;
          gameController.symbolAnimator.animateSymbols(
            [
              {
                cell: { reel: award.coord.reel, row: award.coord.row },
                symbolId: symbols["Symbol_Hammer_Prize"].ID,
              },
            ],
            gameController.slotMachine,
            true,
            false,
            function () {
              if (award.isDoubled) {
                self._fireslots.animateX2(
                  award.coord.reel,
                  award.coord.row,
                  function () {
                    self.increaseVolcanoPot(award.newVolcanPot, function () {
                      callback();
                    });
                  }
                );
              } else {
                self.increaseVolcanoPot(award.newVolcanPot, function () {
                  callback();
                });
              }
            }
          );
          break;
        }
        case "X2Activated": {
          callback();
          break;
        }
        case "VolcanoPrize": {
          const self = this;
          soundManager.play("freeSpinsHammerLand");
          const symbols = resourceManager.getConfiguration().symbols;
          gameController.symbolAnimator.animateSymbols(
            [
              {
                cell: { reel: award.coord.reel, row: award.coord.row },
                symbolId: symbols["Symbol_Hammer_Prize"].ID,
              },
            ],
            gameController.slotMachine,
            true,
            false,
            function () {
              if (award.isDoubled) {
                self.countVolcanoPotBeforeMoving(award.winAmount, function () {
                  self.increaseVolcanoWinnings(
                    self._fireballAwardWinnings + award.winAmount,
                    function () {
                      callback();
                    }
                  );
                });
              } else {
                self.increaseVolcanoWinnings(
                  self._fireballAwardWinnings + award.winAmount,
                  function () {
                    callback();
                  }
                );
              }
            }
          );
          break;
        }
        case "Retrigger": {
          const self = this;

          if (this._bonusSymbolPos) {
            const symbols = resourceManager.getConfiguration().symbols;
            let symbolData = {
              cell: this._bonusSymbolPos,
              symbolId: symbols["Symbol_Bonus_Retrigger"].ID,
            };

            soundManager.play("freeSpinsBonusWon");

            gameController.symbolLandAnimator.animateSymbols(
              [symbolData],
              gameController.slotMachine,
              true,
              true,
              function () {
                self._retriggerPopup.show(award.spinsAdded, function () {
                  self._spinsLeft += award.spinsAdded;
                  self._freespinsCount += award.spinsAdded;
                  self.updateCountText();
                  callback();
                });
              }
            );
          } else {
            console.log("Error: failed to find retrigger symbol");
            this._retriggerPopup.show(award.spinsAdded, function () {
              self._spinsLeft += award.spinsAdded;
              self._freespinsCount += award.spinsAdded;
              self.updateCountText();
              callback();
            });
          }
          break;
        }
        default: {
          console.log("error");
          callback();
          break;
        }
      }
    }

    onFireballAwardsEvent(task) {
      task.join();
      this._currentVolcanoWinnings = 0;
      //this._fireballAwardWinnings = 0;

      this._fireballAwardWinnings = this._winningsThisSpin;
      this._fireballAwardsTask = task;
      if (task.data.fireballAwards) {
        const self = this;
        timerManager.addTimer(
          800,
          function () {},
          function () {
            self.processFireballAwards(function () {
              self._firelink.showWinningsPanel(false, function () {
                self.endSpin(self._fireballAwardsTask, 800);
              });
            });
          }
        );
      } else {
        this.endSpin(this._fireballAwardsTask, 500);
      }
    }

    endSpin(task, time) {
      gameController.winningsContainer.visible = true;

      if (this._winningsThisSpin > 0 || this._fireballAwardWinnings > 0) {
        gameData.musicManager.increaseLevel("freeSpins");
      }

      // take back off the winnings this spin else we will count them twice - not ideal
      this._fireballAwardWinnings -= this._winningsThisSpin;

      this._winningsThisSpin += this._fireballAwardWinnings;
      this._winnings += this._fireballAwardWinnings;
      gameController.freespinsWinnings += this._fireballAwardWinnings;
      gameData.winningsMeter.set(this._winningsThisSpin);
      this._fsWinningsMeter.set(this._winnings);
      timerManager.addTimeout(time, function () {
        task.leave();
      });
    }

    increaseVolcanoWinnings(newValue, callback) {
      const start = this._fireballAwardWinnings;
      const end = newValue;

      this._fireballAwardsContainer.visible = true;

      const self = this;

      this.playWinLightning(1000);

      timerManager.addTimer(
        1000,
        function (progress) {
          const val = Math.floor(start + (end - start) * progress);
          self._fireballAwardsValue.setText(gdk.formatCurrency(val));

          let newScale = 1 + 0.25 * Math.abs(Math.sin(Math.PI * progress));
          self._fireballAwardsValue.scale.set(newScale, newScale);
        },
        function () {
          self._fireballAwardsValue.setText(gdk.formatCurrency(newValue));
          self._fireballAwardsValue.scale.set(1, 1);
          self._fireballAwardWinnings = newValue;
          callback();
        }
      );
    }

    playPotLightning(duration) {
      const self = this;

      game.thunderAnim.play(0);
      soundManager.play("thunder");
      soundManager.play("lightningPunch");

      this._lightningHammerPot.gotoAndPlay(0);
      this._lightningHammerPot.visible = true;

      timerManager.addTimer(
        duration,
        function () {},
        function () {
          self._lightningHammerPot.gotoAndStop(0);
          self._lightningHammerPot.visible = false;
        }
      );
    }

    playWinLightning(duration) {
      const self = this;

      game.thunderAnim.play(0);
      soundManager.play("thunder");
      soundManager.play("lightningPunch");

      this._lightningWinPanel.gotoAndPlay(0);
      this._lightningWinPanel.visible = true;

      timerManager.addTimer(
        duration,
        function () {},
        function () {
          self._lightningWinPanel.gotoAndStop(0);
          self._lightningWinPanel.visible = false;
        }
      );
    }

    countVolcanoPotBeforeMoving(newValue, callback) {
      this._volcanoWinValue.visible = true;
      callback();
    }

    doubleVolcanoPot(award, callback) {
      const start = this._currentVolcanoPotValue;
      const end = award.newPotAmount;
      const self = this;

      this.showPotIncrease(end - this._currentVolcanoPotValue, 1200);

      this.playPotLightning(1200);

      const pos = this._firelink.getPositionForPinkWinline(
        award.coord.reel,
        award.coord.row
      );
      this._firelink.playPinkWinline(pos.x, pos.y);

      timerManager.addTimer(
        1200,
        function (progress) {
          const val = Math.floor(start + (end - start) * progress);
          self._volcanoWinValue.setText(gdk.formatCurrency(val));
        },
        function () {
          self._volcanoWinValue.setText(gdk.formatCurrency(end));
          self._currentVolcanoPotValue = end;
          callback();
        }
      );
    }

    increaseVolcanoPot(newValue, callback) {
      const start = this._currentVolcanoPotValue;
      const end = newValue;
      const self = this;

      this.showPotIncrease(newValue - this._currentVolcanoPotValue, 1200);

      this.playPotLightning(1200);

      timerManager.addTimer(
        1200,
        function (progress) {
          const val = Math.floor(start + (end - start) * progress);
          self._volcanoWinValue.setText(gdk.formatCurrency(val));
        },
        function () {
          self._volcanoWinValue.setText(gdk.formatCurrency(end));
          self._currentVolcanoPotValue = newValue;
          callback();
        }
      );
    }

    showPotIncrease(amount, duration) {
      this._potIncrease.visible = true;
      this._potIncrease.setText("+" + gdk.formatCurrency(amount));
      this._potIncrease.alpha = 0;

      this._potIncreaseHighlight.visible = true;
      this._potIncreaseHighlight.setText("+" + gdk.formatCurrency(amount));
      this._potIncreaseHighlight.alpha = 0;

      this._potIncreaseGlow.visible = true;
      this._potIncreaseGlow.alpha = 0;
      this._potIncreaseGlow.rotation = 0;

      gsap.to(this._potIncreaseGlow, {
        duration: 2,
        rotation: Math.PI / 2,
      });

      const self = this;

      gsap
        .timeline()
        .to(this._potIncrease, {
          duration: 0.2,
          alpha: 1,
        })
        .to(
          this._potIncreaseGlow,
          {
            duration: 0.2,
            alpha: 0.4,
          },
          "<"
        )
        .to(this._potIncreaseHighlight, {
          duration: 0.2,
          alpha: 1,
        })
        .to(this._potIncreaseHighlight, {
          duration: 0.5,
          delay: 0.2,
          alpha: 0,
        });

      timerManager.addTimer(
        duration,
        function () {},
        function () {
          gsap.to([self._potIncrease, self._potIncreaseGlow], {
            duration: 0.2,
            alpha: 0,
            onComplete: () => {
              self._potIncrease.visible = false;
            },
          });
        }
      );
    }

    showVolcanoWinningsPanel(show, callback) {
      if (
        (show && !this._fireballAwardsContainer.visible) ||
        (!show && this._fireballAwardsContainer.visible)
      ) {
        if (show) {
          this._fireballAwardsContainer.visible = true;
          this._fireballAwardsContainer.alpha = 0;
        }
        const self = this;
        timerManager.addTimer(
          500,
          function (progress) {
            if (show) {
              self._fireballAwardsContainer.alpha = progress;
            } else {
              self._fireballAwardsContainer.alpha = 1 - progress;
            }
          },
          function () {
            self._fireballAwardsContainer.alpha = 1;
            if (!show) {
              self._fireballAwardsContainer.visible = false;
            }
            callback();
          }
        );
      } else {
        callback();
      }
    }

    onFreespinsStart(task) {
      this._startHolder = task;
      this._startHolder.join();

      const symbolsInfo = resourceManager.getConfiguration().symbols;
      let symbols = [];
      for (let i = 0; i < task.data.bonusSymbolPositions.length; ++i) {
        symbols.push({
          cell: {
            reel: task.data.bonusSymbolPositions[i].reel,
            row: task.data.bonusSymbolPositions[i].row,
          },
          symbolId: symbolsInfo["Symbol_Bonus"].ID,
        });
      }

      // stop the base theme when freespins scatters play
      //gameData.musicManager.dimBaseMusic();

      // note - plays the sound 3 times as the anim repeats 3 times
      const self = this;

      timerManager.addTimer(
        800,
        function () {},
        function () {
          soundManager.play("bonusWon");

          gameController.symbolLandAnimator.skip();

          gameController.symbolAnimator.animateSymbols(
            symbols,
            gameController.slotMachine,
            true,
            false,
            function () {
              gameController.symbolAnimator.animateSymbols(
                symbols,
                gameController.slotMachine,
                true,
                false,
                function () {
                  gameController.symbolAnimator.animateSymbols(
                    symbols,
                    gameController.slotMachine,
                    true,
                    false,
                    function () {
                      self.start(task);
                    }
                  );
                }
              );
            }
          );
        }
      );
    }

    start(task) {
      resourceManager.get("hammerPotContainer").visible = true;
      resourceManager.getContainer("freespinsContainer").visible = true;
      resourceManager.getContainer(
        "freespinsBehindGameContainer"
      ).visible = true;

      gameController.slotMachine.clearDimSymbolIds();

      resourceManager.getController("inputOverlord").setState("freespins");
      messageBus.subscribe("spinner:SpinEvent", this._doSpinFunc);
      messageBus.subscribe("spinner:SpinEventDead", this._doSpinDeadFunc);
      messageBus.subscribe(
        "spinner:WinningLinesEventDead",
        this._payWinsDeadFunc
      );
      messageBus.subscribe(
        "8bof:FireballLinkStartEvent",
        this._onfireballLinkStartEventFunc
      );
      messageBus.subscribe(
        "8bof:FireballLinkEndEventDead",
        this._onfireballLinkEndEventFunc
      );

      gameController.slotMachine.selectReelMode("freespins");

      gameController.freespinsWinnings = 0;
      gameController.inFreeSpins = true;

      this._winnings = 0;
      this._freespinsCount = task.data.freeSpinsAwarded;
      // this._introFsCount.setTranslationParameters(this._freespinsCount);
      this._spinsLeft = task.data.freeSpinsAwarded - 1;
      let bonusWin = 0;
      if (task.data.bonusWin) {
        bonusWin = task.data.bonusWin;
      }
      this._winnings += gameController.preFSReelPrize;
      gameController.freespinsWinnings += gameController.preFSReelPrize;
      this._fsWinningsMeter.set(gameController.preFSReelPrize + bonusWin);
      this._fsCountText.setTranslationParameters(
        this._freespinsCount - this._spinsLeft,
        this._freespinsCount
      );
      this._fsCountText.visible = true;

      this._currentVolcanoPotValue = 0;
      this._volcanoWinValue.setText("0.00");

      this._fsActive = true;
      this.onOrientationChange();

      this._freespinElements.forEach(function (element) {
        element.visible = true;
        element.alpha = 0;
      });

      this._bg.visible = true;
      this._bg.alpha = 0;

      const self = this;
      timerManager.addTimer(
        1000,
        function (progress) {
          self._freespinElements.forEach(function (element) {
            element.alpha = progress;
          });
          self._popupMaskDimObject.show(true, progress);
          self._introPopup.alpha = progress;
          self._logo.alpha = progress - 1;
          self._bg.alpha = progress;
        },
        function () {
          //soundManager.setVolume(1,this._introPopupTuneId);
          self._freespinElements.forEach(function (element) {
            element.alpha = 1;
          });
          self._logo.alpha = 1;
          self._logo.visible = false;

          self._introPopup.alpha = 1;

          self._introPopup.showIntro(
            self._freespinsCount,
            self.introComplete.bind(self)
          );
          self._popupMaskDimObject.show(true, 1);

          self._bg.alpha = 1;
        }
      );
    }

    introComplete() {
      this._popupMaskDimObject.show(false);

      gameData.musicManager.fadeLevels(0, "freeSpins");

      this.doInitialVolcanoSeed();
    }

    doInitialVolcanoSeed() {
      const self = this;

      let scatterPositions = [];
      let volcanoPotValue = 0;
      this._startHolder.data.volcanoBoosts.forEach(function (boost) {
        volcanoPotValue += boost.boostAmount;
        scatterPositions.push({
          reel: boost.coord.reel,
          row: boost.coord.row,
          state: 2,
        });
      });

      timerManager.addTimer(
        1000,
        function (progress) {
          const val = volcanoPotValue * progress;
          self._volcanoWinValue.setText(gdk.formatCurrency(val));
        },
        function () {
          self._currentVolcanoPotValue = volcanoPotValue;
          self._volcanoWinValue.setText(gdk.formatCurrency(volcanoPotValue));

          self._startHolder.leave();
        }
      );
    }

    onFreespinsStartDead(task) {
      this.getNextSpinOutcome();
    }

    onFreespinsAwardedEnd() {}

    onFreespinsData(task) {
      console.log("");
    }

    onFreespinsDataDeadEvent(task) {
      this._spinsLeft--;

      if (!this._inFBL) {
        if (this._winningsThisSpin > 0) {
          this.getNextSpinOutcome();
        } else {
          const self = this;
          timerManager.addTimer(450, undefined, function () {
            self.getNextSpinOutcome();
          });
        }
      }
    }

    onFreespinsEndEvent(task) {
      this._endHolder = task;
      this._endHolder.join();

      gameController.slotMachine.clearDimSymbolIds();

      messageBus.unsubscribe("spinner:SpinEvent", this._doSpinFunc);
      messageBus.unsubscribe(
        "spinner:WinningLinesEventDead",
        this._payWinsDeadFunc
      );
      messageBus.unsubscribe("spinner:SpinEventDead", this._doSpinDeadFunc);
      messageBus.unsubscribe(
        "8bof:FireballLinkStartEvent",
        this._onfireballLinkStartEventFunc
      );
      messageBus.unsubscribe(
        "8bof:FireballLinkEndEventDead",
        this._onfireballLinkEndEventFunc
      );

      gameController.slotMachine.selectReelMode("default");

      this._outroPopupWinValue.setText(gdk.formatCurrency(this._winnings));
      this._outroPopup = this._outroPopupWin;
      this._outroPopupButton = this._outroPopupWinButton;

      this.stateMachine.switchState("PREBIGWIN");
    }

    update_preBigWinState() {
      if (this.phase.enter()) {
      }

      if (this.phase.once()) {
      }

      if (this.phase.hold()) {
        if (!soundManager.isSoundPlaying("eb_bonus_end_v1")) {
          this.phase.step();
        }
      }

      if (this.phase.once()) {
        if (gameController.bigWin.checkBigWin(this._winnings)) {
          const self = this;
          gameController.bigWin.clearSkippedFlag();

          gameController.bigWin.start(
            this._winnings,
            function () {
              gameController.winningsContainer.visible = true;
              self.stateMachine.switchState("OUTRO");
            },
            false,
            false,
            function () {},
            false,
            this._endHolder.data.isCapped
          );
        } else {
          soundManager.play("bonusEnd");
          this.stateMachine.switchState("OUTRO_POPUP");
        }
      }
    }

    doPayWins(task) {
      this._winningsThisSpin = task.data.totalLineWinnings;
    }

    doPayWinsDead(task) {
      this._winnings += task.totalLineWinnings;
      gameController.freespinsWinnings += task.totalLineWinnings;

      const total = this._winningsThisSpin;

      if (this._fsActive && total > 0) {
        this._fireballAwardsContainer.visible = true;
        const self = this;

        timerManager.addTimer(
          1000,
          function (progress) {
            const val = total * progress;
            self._fireballAwardsValue.setText(gdk.formatCurrency(val));
          },
          function () {
            self._fireballAwardsValue.setText(gdk.formatCurrency(total));
          }
        );
      }
    }
  }

  new Freespins();
})();
